import { yupResolver } from '@hookform/resolvers/yup';
import axios from 'axios';
import { useLayoutEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { Button } from '@/components/shadcn/button.tsx';
//import Button from '@/components/UI/Button';
import { HookForm } from '@/components/UI/HookForm/Form';
import { HookInput } from '@/components/UI/HookForm/Form/Input';
import { HookFormProvider } from '@/components/UI/HookForm/Provider';
import { authSelector, useAppDispatch, useAppSelector } from '@/store';
import { SignInUser } from '@/store/Auth';
import { getOnboardingRedirectPath } from '@/utils/authOnboarding';
import { validationSchema } from './validationSchema';

interface SignInInterface {
  email: string;
  password: string;
}

function SignIn({ slideHandler }: { slideHandler: () => void }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const auth = useAppSelector(authSelector);
  const verifiedEmail = searchParams.get('email') || '';
  const wasEmailVerified = searchParams.get('verified') === '1';

  useLayoutEffect(() => {
    if (auth.isLoggedIn) {
      axios.defaults.headers.common['x-subdomain'] = auth.currentDomain;
      localStorage.setItem('xSubdomain', auth.currentDomain);
      const nextPath = getOnboardingRedirectPath(auth.data.onboardingProfile);

      if (nextPath) {
        navigate(nextPath, { replace: true });
        return;
      }

      const redirectPath = auth.data.isSuper ? '/os/clients' : '/terminal/dashboard';
      navigate(redirectPath, { replace: true });
    }
  }, [auth, navigate]);

  const onSubmit = async (data: SignInInterface) => {
    dispatch(SignInUser(data));
  };

  const renderError = () => {
    return <span className='text-red-500'>{auth.errorMsg}</span>;
  };

  return (
    <div className='flex items-center gap-8'>
      <HookFormProvider resolver={yupResolver(validationSchema)} mode='all' defaultValues={{ email: verifiedEmail, password: '' }}>
        <HookForm noDefaultClass className='bg-white shadow-md rounded-md px-8 pt-6 pb-8 border-t-2' onSubmit={onSubmit}>
          <h2 className='mt-0'>Sign In</h2>
          {wasEmailVerified && (
            <p className='mb-4 rounded-md border border-green-200 bg-green-50 px-3 py-2 text-sm text-green-800'>
              Email verified. Sign in to continue your SEIN Terminal setup.
            </p>
          )}
          {auth.error && auth.signInAttempted && <p className='mb-2'>{renderError()}</p>}

          <div className='space-y-4 w-full'>
            <HookInput label='Email' name='email' type='email' placeholder='Enter your email' className='min-w-[310px]' />
            <HookInput label='Password' name='password' type='password' placeholder='Enter your password' className='min-w-[310px]' />
          </div>
          <p className='text-xs text-neutralColor-normal hover:text-secondaryColor-normal cursor-pointer mb-8 mt-2' onClick={slideHandler}>
            Forgot Your Password ?
          </p>
          <Button
            className='w-full bg-green-900'
            //label=
            type='submit'
            disabled={auth.loading}
          >
            {`${auth.loading ? 'Please Wait...' : 'Sign In'}`}
          </Button>
        </HookForm>
      </HookFormProvider>
    </div>
  );
}

export default SignIn;
